module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    attrs: {
      "id": "sessao-vigencia"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', [_c('icon', {
    attrs: {
      "name": "calendar"
    }
  }), _vm._v(" Vigência")], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataQuotation.quotation_date),
      expression: "dataQuotation.quotation_date"
    }],
    attrs: {
      "type": "hidden",
      "name": "quotation_date"
    },
    domProps: {
      "value": (_vm.dataQuotation.quotation_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dataQuotation, "quotation_date", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.validity_start')
    }
  }, [_vm._m(0, false, false), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          date_valid: true
        }
      }),
      expression: "{ rules: { required: true, date_valid: true } }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dataQuotation.validity_start),
      expression: "dataQuotation.validity_start"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "validity_start",
      "data-vv-as": "Início Vigência"
    },
    domProps: {
      "value": (_vm.dataQuotation.validity_start)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dataQuotation, "validity_start", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('data.validity_start')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.validity_start')))]) : _vm._e()])]), _vm._v(" "), (this.$root.$options.config.insureLine !== 'life') ? _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.validity_end')
    }
  }, [_vm._m(1, false, false), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          date_valid: true
        }
      }),
      expression: "{ rules: { required: true, date_valid: true } }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dataQuotation.validity_end),
      expression: "dataQuotation.validity_end"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "validity_end",
      "data-vv-as": "Fim Vigência"
    },
    domProps: {
      "value": (_vm.dataQuotation.validity_end)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dataQuotation, "validity_end", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('data.validity_end')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.validity_end')))]) : _vm._e()])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Início Vigência "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Fim Vigência "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14d3f39a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared/modules/QuotationNew/FormPartialQuotation.vue
// module id = 332
// module chunks = 0